<template>
  <div class="hello">
    <el-row class="tac" style="background-color:#545C64;height:100%;">
      <el-menu :default-active="defaultActive" router class="el-menu-vertical-demo" @select="handleSelect" background-color="#283142" text-color="#fff"  style="height:100%;overflow: hidden;border-right:0px;">
        <el-menu-item index="/index">
          <i class="el-icon-menu"></i>
          <span slot="title">首页</span>
        </el-menu-item>
        <el-menu-item index="/Recharge">
          <i class="el-icon-news"></i>
          <span slot="title">我要充值</span>
        </el-menu-item>
        <el-menu-item index="/withdrawdeposit">
          <i class="el-icon-printer"></i>
          <span slot="title">我要提现</span>
        </el-menu-item>
        <el-menu-item index="/history" v-show="isShowCashRecord">
          <template slot="title">
            <i class="el-icon-date"></i>
            <span>历史记录</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/personaldata">
          <template slot="title">
            <i class="el-icon-setting"></i>
            <span>个人资料</span>
          </template>
        </el-menu-item>
      </el-menu>
    </el-row>
  </div>
</template>

<script>
import Bus from '@/assets/js/bus'
export default {
  //
  name: "asides",
  data() {
    return {
      defaultActive:"/index",
      isShowCashRecord: true
    };
  },
  created() {
    if (sessionStorage.getItem('isShowCashRecord') !== 'undefined' && sessionStorage.getItem('isShowCashRecord') !== '') {
      this.isShowCashRecord = JSON.parse(sessionStorage.getItem('isShowCashRecord'));
    }
    this.defaultActive = "/" + window.location.hash.split("?")[0].split("/")[1];
  },
  mounted(){
    var self = this
    Bus.$on('activeIndex1',function(defaultActive) {
       self.defaultActive = "/index"
    })
    Bus.$on('activeIndex2',function(defaultActive) {
       self.defaultActive = defaultActive
    })
    Bus.$on('activeIndex3',function(defaultActive) {
      self.defaultActive = defaultActive;
    })
     Bus.$on('activeIndex4',function() {
      self.defaultActive =  "/personaldata"
    })
  },
  methods: {
     handleSelect(key, keyPath) {
        // console.log(key, keyPath);
        this.defaultActive = key
      }
  },
  watch: {
  }
};
</script>

<style scoped>
.fa {
  padding-left: 5px;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/aside.vue